import { render, staticRenderFns } from "./AsignedThecnicians.vue?vue&type=template&id=059b6706&scoped=true&"
import script from "./AsignedThecnicians.vue?vue&type=script&lang=js&"
export * from "./AsignedThecnicians.vue?vue&type=script&lang=js&"
import style0 from "./AsignedThecnicians.vue?vue&type=style&index=0&id=059b6706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b6706",
  null
  
)

export default component.exports